import { lazy } from "react"
import { SaleChestType } from "store/apis/saleChestAPI"

export const SALE_CHEST_MODALS = {
  saleChestInfo: {
    component: lazy(() => import("modals/ui/sale-chest/sale-chest-info-modal"))
  },
  saleChestPurchaseSuccess: {
    component: lazy(
      () => import("modals/ui/sale-chest/sale-chest-purchase-success-modal")
    ),
    params: {} as {
      chestType: SaleChestType
      chestImgSrc?: string
      packageSize: number
    }
  }
} as const
